var count = 0;

export default function(name) {
  return new Id("O-" + (name == null ? "" : name + "-") + ++count);
}

export function Id(id) {
  this.id = id;
  this.href = new URL(`#${id}`, location) + "";
}

Id.prototype.toString = function() {
  return "url(" + this.href + ")";
};

